import React, { useEffect, useState, useMemo} from 'react';
import { useSelector } from 'react-redux';
import { Dropdown } from 'app/components';
import { CaretLeft } from '@phosphor-icons/react';
import TicketContainer from './TicketContainer';
import { getTicketDetails } from '../api';
import mixpanel from 'mixpanel-browser';
import './style';


const TicketList = ({ eventData, onClick, cat, handleOpen }) => {
  const { activeRequests , userData} = useSelector((state) => state.app);
  const { ticketDetails: tickets } = useSelector((state) => state.buyerFlow);

  const [sortOption, setSortOption] = useState('Recent');
  const [openTicketId, setOpenTicketId] = useState(null); 

  useEffect(() => {
    window.scrollTo(0, 0);
    getTicketDetails(eventData?._id, cat?.categoryName);
  }, [eventData, cat]);

  const sortedTicketList = useMemo(() => {
    let sortedList = [...(tickets || [])];
    console.log(sortOption)
    if (sortOption === 'Recent') {
      sortedList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (sortOption === 'Price') {
      sortedList.sort((a, b) => a.ticketPrice - b.ticketPrice);
    }
    return sortedList;
  }, [tickets, sortOption]);

  const handleSortChange = (selectedOption) => {
    setSortOption(selectedOption); 
  };

  const handleToggle = (ticketId, t) => {
    mixpanel.track("Seller_Viewed", {
      "event_id": eventData?._id,                  
      "event_name": eventData?.name,              
      "category_name": t?.ticketCategoryName,       
      "seller_name": t?.user?.name,          
      "seller_id": t?.user?._id,          
      "ticket_price": t?.ticketPrice,        
      "user_id": userData?._id || "Anonymous",    
      "page_url": window.location.href,     
    });
    setOpenTicketId((prev) => (prev === ticketId ? null : ticketId));
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '';
    }

    const weekdayOptions = { weekday: 'short' };
    const monthDayOptions = { month: 'short', day: 'numeric' };
    const timeOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

    const weekday = new Intl.DateTimeFormat('en-US', weekdayOptions).format(
      date,
    );
    const monthDay = new Intl.DateTimeFormat('en-US', monthDayOptions).format(
      date,
    );
    const time = new Intl.DateTimeFormat('en-US', timeOptions).format(date);

    return `${weekday}, ${monthDay} at ${time}`;
  }

  // if (activeRequests?.includes('get-ticket-details')) return <div>loading...</div>;

  return (
    <div className="w-[660px] h-full flex flex-col gap-[48px] mx-auto mt-12 mb-[10px] ticketListContainer">
      <div className="flex gap-5 items-center ticketNameContainer">
        <div className="p-2 bd-1 cursor-pointer"
          onClick={onClick}>
          <CaretLeft size={20.571}
            className="cursor-pointer" />
        </div>
        <div className="flex gap-4 ticketName">
          <h1 className="heading-16">{eventData?.name}</h1>
          <p className="label-16 text-[#717171]">
            {formatDate(eventData?.start_date)}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <h1 className="heading-36 ticketCardHeading">
          {sortedTicketList.length > 0 &&
            sortedTicketList[0]?.ticketCategoryName}
        </h1>
        <div className="ml-auto flex gap-4 items-center">
          <p className="label-14 text-[#717171]">Sort by:</p>
          <Dropdown
            options={[
              {
                id: 'Recent',
                label: 'Recent',
              },
              {
                id: 'Price',
                label: 'Price',
              },
            ]}
            value={sortOption}
            showSelection={true}
            width={137}
            className="h-[40px]"
            onChange={(value) => handleSortChange(value)} 
          />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        {sortedTicketList?.map((t) => (
          <TicketContainer
            ticketInfo={t}
            cat={cat}
            handleOpen={handleOpen}
            eventData={eventData}
            key={t._id}
            isOpen={openTicketId === t._id}
            onToggle={() => handleToggle(t._id, t)}
          />
        ))}
      </div>
    </div>
  );
};

export default TicketList;
